import { render } from "./Kegiatancsr.vue?vue&type=template&id=b3130a2c&scoped=true"
import script from "./Kegiatancsr.vue?vue&type=script&lang=js"
export * from "./Kegiatancsr.vue?vue&type=script&lang=js"

import "./Kegiatancsr.vue?vue&type=style&index=0&id=b3130a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3130a2c"]])

export default __exports__